import { IS_APPLE } from 'src/common/utils/environment';

export const ShortcutSystemSymbol = IS_APPLE ? '⌘' : 'Ctrl';

export const ShortcutOption = IS_APPLE ? '⌥' : 'Alt';
